import React from 'react';
import { Controller } from 'react-hook-form';
import { translate } from '@utils/i18n';
import WizardView from '@components/WizardView';
const namespace = 'features.settings.service_trade';
export default function CredentialsStep({ control, onNext, onCancel, isLoading, isValid, error }) {
    const actions = [
        {
            label: translate('cancel', { namespace: 'generic' }),
            onClick: onCancel,
            variant: 'secondary',
            disabled: isLoading
        },
        {
            label: translate('wizard.check_connection', { namespace }),
            onClick: onNext,
            variant: 'primary',
            disabled: !isValid || isLoading,
            isLoading
        }
    ];
    return (React.createElement(WizardView, { title: translate('wizard.credentials_title', { namespace }), description: translate('wizard.credentials_description', { namespace }), actions: actions, error: error },
        React.createElement("div", { className: "qmb-input" },
            React.createElement(Controller, { name: "username", control: control, rules: {
                    required: translate('wizard.username_required', { namespace })
                }, render: ({ field, fieldState }) => (React.createElement(React.Fragment, null,
                    React.createElement("input", Object.assign({}, field, { type: "text", id: "st-username", placeholder: " ", disabled: isLoading, "aria-invalid": !!fieldState.error })),
                    React.createElement("label", { htmlFor: "st-username", className: "qmb-label" }, translate('wizard.username', { namespace })),
                    fieldState.error && (React.createElement("span", { className: "qmb-input__error" }, fieldState.error.message)))) })),
        React.createElement("div", { className: "qmb-input" },
            React.createElement(Controller, { name: "password", control: control, rules: {
                    required: translate('wizard.password_required', { namespace })
                }, render: ({ field, fieldState }) => (React.createElement(React.Fragment, null,
                    React.createElement("input", Object.assign({}, field, { type: "password", id: "st-password", placeholder: " ", disabled: isLoading, "aria-invalid": !!fieldState.error })),
                    React.createElement("label", { htmlFor: "st-password", className: "qmb-label" }, translate('wizard.password', { namespace })),
                    fieldState.error && (React.createElement("span", { className: "qmb-input__error" }, fieldState.error.message)))) }))));
}
